import { render } from "./DevcoTag.vue?vue&type=template&id=d76dee98"
import script from "./DevcoTag.vue?vue&type=script&lang=js"
export * from "./DevcoTag.vue?vue&type=script&lang=js"

import "./DevcoTag.vue?vue&type=style&index=0&id=d76dee98&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__